import React from "react";
import AdminUsersTable from "../components/users/AdminUsersTable";

/**
 * Admin User Page
 * - Lists all users
 * - Provides Show More button to navigate to user details
 */
const AdminUserPage = () => {
  return (
    <div style={{ padding: "20px" }}>
      <h1>Admin - Users</h1>
      <p>View all registered users and manage their accounts.</p>
      <AdminUsersTable />
    </div>
  );
};

export default AdminUserPage;
